import {useDebugValue} from 'react';

import {
    useCookies,
    useSystem,
    useMedia,
    useAbacus,
    useEdap,
    useSearch,
    useForm,
    useDestination,
    useDates,
    useGuests,
    useSubmit
} from './';

function useSearchFormContext(props) {
    const cookies = useCookies();

    const system = useSystem(props);
    const media = useMedia(props);

    const abacus = useAbacus(props);

    const edap = useEdap(props);

    const search = useSearch(props);

    const form = useForm(props);

    const destination = useDestination(props, cookies, system, abacus);
    const dates = useDates(props, cookies, system, abacus);
    const guests = useGuests(props, cookies, system, abacus);

    const submit = useSubmit(props);

    const result = {
        system,
        media,
        abacus,
        edap,
        search,
        form,
        destination,
        dates,
        guests,
        submit
    };

    useDebugValue(result);

    return result;
}

export {useSearchFormContext};
